import i18n from 'i18n';
import * as Yup from 'yup';

export const createPlatformValidationSchema = Yup.object().shape({
  address: Yup.string().required(i18n.t('loginForm.emptyAddress')),
  mapPosition: Yup.string().required(i18n.t('loginForm.emptyMapPosition')),
  wim: Yup.string().required(i18n.t('loginForm.emptyWim')),
});
